import React from 'react';
import { alpha } from '@mui/system';
import { SettingsIcon } from '../../assets';
import { themeObject } from '../../lib';

export type SettingsRadioOptionTypes = '' | 'off' | 'on';

export interface ElevateSystemWallet {
    id: string;
    description: string;
    type: string;
    hash: string;
    accessControlUserGroup: string;
    timestamp: string;
    author: string;
}

export const settingsRadioButtons: {
    label: string;
    value: string;
}[] = [
    {
        label: 'Off',
        value: 'off',
    },
    {
        label: 'On',
        value: 'on',
    },
];

interface SettingsConfig {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
}

export const settingsConfig: SettingsConfig = {
    settings: {
        imgSrc: SettingsIcon,
        headingText: 'Settings',
        iconStyles: {
            width: '128px',
            height: '78px',
        },
    },
};

export const settingsStyles = {
    root: {
        '& .MuiBackdrop-root': {
            backgroundColor: alpha(themeObject.palette.grayScale[50], 0.75),
        },
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                height: '100vh',
                width: '864px',
                maxWidth: 'none',
                maxHeight: 'none',
                boxShadow: 'none',
            },
        },
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 1.5,
        mx: '143.5px',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
    },
    descriptionContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    elevationRadioGroupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    systemWalletListContainer: {
        mt: 2.5,
    },
    elevateSystemWalletListText: {
        ...themeObject.typography.inputLabel,
        color: themeObject.palette.grayScale[800],
        lineHeight: '21.17px',
        letterSpacing: '0.15px',
        mb: 2.5,
    },
    titleLabel: {
        ...themeObject.typography.inputLabel,
        lineHeight: '21.17px',
        letterSpacing: '0.15px',
        color: themeObject.palette.grayScale[800],
        mb: 0.5,
    },
    subtitleLabel: {
        ...themeObject.typography.captions.default,
        color: themeObject.palette.grayScale[800],
        mb: 0.5,
    },
    radioButton: {
        height: '40px',
        width: '40px',
    },
    menuItemStyle: {
        width: '577px',
        height: '65px',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        alignItems: 'center',
        borderRadius: '10px',
        m: '12px 0',
        '&:hover': {
            backgroundColor: alpha(themeObject.palette.primary[50], 0.5),
        },
    },
    listItemStyle: {
        '& span': {
            fontFamily: `Red Hat Text !important`,
            fontWeight: `700 !important`,
            fontSize: '16px !important',
            color: `${themeObject.palette.primary[700]} !important`,
            textOverflow: 'ellipsis',
            wordBreak: 'break-all',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
        },
    },
    secondaryMenuItemTextContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    walletTypeTextContainer: {
        display: 'flex',
        flexDirection: 'row',
        ml: 2,
    },
    menuItemSecondaryTextId: {
        width: '230px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...themeObject.typography.captions.default,
        ...themeObject.typography.captions.regular,
        color: themeObject.palette.grayScale[800],
    },
    menuItemSecondaryText: {
        width: '140px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...themeObject.typography.captions.default,
        ...themeObject.typography.captions.regular,
        color: themeObject.palette.grayScale[800],
    },
    menuItemSecondaryTextBold: {
        ...themeObject.typography.captions.default,
        ...themeObject.typography.captions.semibold,
        color: themeObject.palette.grayScale[800],
    },
};
